import { create } from 'zustand';

export interface OneToOneMeetingFilterObject {
	filter_date: { flagged: boolean; startDate: Date | null; endDate: Date | null };
	typeOfDiscussion: string;
	typeOfUser: string;
	meetingType: string;
}

export type OneToOneMeetingSortValue = 'createddate_desc' | 'createddate_asc' | '';

const initialOneToOneMeetingFilterObject: OneToOneMeetingFilterObject = {
	filter_date: { flagged: false, startDate: null, endDate: null },
	typeOfUser: '',
	typeOfDiscussion: '',
	meetingType: '',
};

interface OneToOneMeetingFilterStore {
	oneToOneMeetingFilterObject: OneToOneMeetingFilterObject;
	search: string;
	sortValue: OneToOneMeetingSortValue;
	updateOneToOneMeetingFilterObject: (filter: OneToOneMeetingFilterObject) => void;
	updateOneToOneMeetingSearch: (search: string) => void;
	updateOneToOneMeetingSortValue: (sortValue: OneToOneMeetingSortValue) => void;
	resetOneToOneMeetingFilterStore: () => void;
}

export const useOneToOneMeetingFilterStore = create<OneToOneMeetingFilterStore>((set) => ({
	oneToOneMeetingFilterObject: { ...initialOneToOneMeetingFilterObject },
	search: '',
	sortValue: '',
	updateOneToOneMeetingFilterObject: (oneToOneMeetingFilterObject): void =>
		set(() => ({ oneToOneMeetingFilterObject: { ...oneToOneMeetingFilterObject } })),
	updateOneToOneMeetingSearch: (search): void => set(() => ({ search })),
	updateOneToOneMeetingSortValue: (sortValue): void => set(() => ({ sortValue })),
	resetOneToOneMeetingFilterStore: (): void =>
		set(() => ({
			oneToOneMeetingFilterObject: { ...initialOneToOneMeetingFilterObject },
			search: '',
			sortValue: '',
		})),
}));
